import styled, { css } from 'styled-components';
import tapume from 'assets/images/tapume.jpg';
import tapumeMobile from 'assets/images/tapume-mobile.jpg';
import play from 'assets/images/play.svg';

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  max-height: 982px;
  position: relative;
`;

interface VideoWrapperProps {
  visible: boolean;
}
export const VideoWrapper = styled.div<VideoWrapperProps>`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  z-index: 2;

  ${({ visible }) =>
    visible &&
    css`
      display: block;
    `}
`;

export const Tapume = styled.img.attrs({ src: tapume })`
  width: 100%;
  object-fit: contain;
  position: relative;
  z-index: 0;

  @media screen and (max-width: 500px) {
    display: none;
  }
`;

export const TapumeMobile = styled.img.attrs({ src: tapumeMobile })`
  width: 100%;
  object-fit: contain;
  position: relative;
  z-index: 0;
  display: none;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

export const PlayButton = styled.button.attrs({ type: 'button' })`
  position: absolute;
  z-index: 1;
  transition: 300ms ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const PlayIcon = styled.img.attrs({ src: play })`
  @media screen and (max-width: 500px) {
    width: 54px;
  }
`;
